import { render, staticRenderFns } from "./currency-flag.vue?vue&type=template&id=dade28ee"
import script from "./currency-flag.ts?vue&type=script&lang=ts&external"
export * from "./currency-flag.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports